<template>
    <div class="sendWarehouseWrap">
        <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="shop" label="店铺">
                <template slot-scope="{row}">
                    {{shopMap[row.shopId].shortTitle || shopMap[row.shopId].title}}
                </template>
            </el-table-column>
            <el-table-column prop="site" label="覆盖站点">
                <template slot-scope="{row}">
                    {{row.siteName}}
                </template>  
            </el-table-column>
            <el-table-column prop="warehouseId" label="发货仓">
                <div slot="header">
                    <span class="red">*</span>发货仓
                </div>
                <template slot-scope="{row}">
                    <el-select v-model="row.warehouseId" placeholder="请选择" @visible-change="(v) => warehouseVisible(v,row.shopId)">
                        <el-option v-for="item in dataMap[row.shopId+'_100'].warehouseList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="stock" label="库存">
                <div slot="header">
                    <span class="red">*</span>库存
                </div>
                <template slot-scope="{row}">
                    <el-input-digit v-model.number="row.stock" placeholder="请输入" :precision="2" />
                </template>
            </el-table-column>
            <el-table-column prop="date" label="运费模版">
                <div slot="header">
                    <span class="red">*</span>运费模版
                </div>
                <template slot-scope="{row}">
                    <el-select v-model="row.value" placeholder="请选择" @visible-change="(v) => freightTempVisible(v,row.shopId)">
                        <el-option v-for="item in dataMap[row.shopId+'_100'].freightTempList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { getWarehouse,getFreightTemp } from '@/servers/prod/center/temu.js';
export default {
    props:{
        shopList: {
            type: Array,
            default() {
                return [];
            },
        },
        siteList:{
            type:Array,
            default:()=>{
                return []
            }
        }
    },
    data(){
        return {
            tableData:[],
            warehouseList:[],
            dataMap:{}
        }
    },
    computed:{
        shopMap(){
            let map = {}
            this.shopList.forEach(shop => {
                map[shop.id] = shop
            });
            return map
        },
    },
    methods:{
        init(){
            let list = [];
            let _dataMap = {}
            this.shopList.forEach(shop => {
                let key = shop.id;
                list.push({siteCode:"",siteName:"",warehouseId:'',warehouseName:"",stock:0,shopId:shop.id})
                _dataMap[key] = {
                    warehouseList:[],
                    freightTempList:[]
                }
            });
            this.tableData = list
            this.dataMap = _dataMap
        },
        // 发货仓下拉框展示/隐藏
        warehouseVisible(v,shopId){
            if(v){
                let key = shopId
                let list = this.dataMap[key].warehouseList
                if(!list.length){
                    this.getWarehouseList(shopId)
                }
            }
        },
        // 运费模版下拉框展示/隐藏
        freightTempVisible(v,shopId){
            if(v){
                let key = shopId
                let list = this.dataMap[key].freightTempList
                if(!list.length){
                    this.getFreightTempList(shopId)
                }
            }
        },
        // 获取发货仓
        getWarehouseList(shopId,siteId){
            if(!shopId){
                return
            }
            let params = {
                shopId:shopId,
                siteId:siteId || '100',
                // supplierId:'',
            }
            getWarehouse(params).then(res => {
                debugger
                let key = shopId
                this.dataMap[key].warehouseList = res
            })
        },
        // 获取运费模版
        getFreightTempList(shopId,siteId){
            let params = {
                shopId,
                siteIds:siteId || 100,
            }
            getFreightTemp(params).then(res => {
                debugger
                let key = shopId
                this.dataMap[key].freightTempList = res
            })
        }
    },
    created(){
        this.init()
    }
}
</script>

<style lang="scss" scoped>
.sendWarehouseWrap{
    .red{
        color: #ff3333;
    }
}
</style>